export const TIPO_PACTAR = 'pactar';
export const TIPO_PROCAMPO_ARS = 'procampodigitalars';
export const TIPO_PROCAMPO_USD = 'procampodigitalusd';